const hoverBtns = document.querySelectorAll('[data-hover-card-hero-btn]');

if (hoverBtns.length) {
    hoverBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const state = btn.dataset.hoverCardHeroBtn;
            if (state === 'closed') {
                btn.setAttribute('data-hover-card-hero-btn', 'open');
            } else {
                btn.setAttribute('data-hover-card-hero-btn', 'closed');
            }
        }, false);
    });
}
